export const SUPER_ADMIN = "superadmin";
export const ADMIN = "admin";
export const INSTRUCTOR = "instructor";
export const STUDENT = "student";
export const COORDINATOR = "coordinator";